import React, { useContext, useState } from "react";
import { ApplicationContext } from "@context/ApplicationContext";
import useTickets from "@context/TicketsContext";
import BookingDetails from "@components/Bookings/BookingDetails";
import InlineMessage from "@components/InlineMessage";
import Button from "@components/Ui/Button";
import Spinner from "@components/Ui/Spinner";
import VoucherList from "@components/VoucherManager/VoucherPurchases/VoucherList";
import VoucherLogo from "@components/VoucherManager/VoucherPurchases/VoucherLogo";

const Voucher = ({ voucher }) => {
    const { whiteLabel } = useContext(ApplicationContext);
    const {
        id,
        loading,
        error,
        errorMessage,
        processing,
        message,
        success,
        reSendTicketEmail
    } = useTickets();

    const isWholesale = whiteLabel?.subscriber_group?.vm_wholesale === true || voucher?.is_wholesale;
    const [emailSent, setEmailSent ] = useState(false);

    const sendTicketEmail = (uuid) => {
        reSendTicketEmail(uuid);
        setEmailSent(!emailSent);
    };

    const downloadVouchersList = (url) => {
        window.location.href = url;
    };

    return (
        <>
            {voucher.ticket_type_id  && voucher.ticket_type_id !== null ? (
                <div className="voucher-history__item" key={id}>
                    {!isWholesale && (
                        <div className="voucher-history__item--voucher">
                            <VoucherLogo item={voucher.items[0]} />
                        </div>
                    )}
                    <div className="voucher-history__block-wrapper">
                        <div className="voucher-history__block">
                            <div className="voucher-history__text">{new Date(voucher.purchase_date).toLocaleDateString()}</div>
                            <div className="voucher-history__text">{voucher.items[0].cinema_group_name}</div>
                            <BookingDetails ticket={voucher} />
                        </div>
                    </div>
                    <div className="voucher-history__vouchers-container">
                        <Button
                            additionalClasses="button button__primary voucher-history__btn"
                            onClick={() => sendTicketEmail(voucher.uuid)}
                            disabled={
                                processing === true && voucher.ticket_id === id
                            }
                        >
                            {loading === true && voucher.ticket_id === id ? (
                                <Spinner text="loading..." />
                            ) : (
                                <span>Resend Voucher Email</span>
                            )}
                        </Button>

                        {error && voucher.ticket_id === id && (
                            <InlineMessage
                                message={errorMessage}
                                messageType="error"
                            />
                        )}
                        {emailSent === true && (
                            <InlineMessage message={message} messageType="success" />
                        )}
                        {success === true && loading === false && voucher.ticket_id === id && (
                            <InlineMessage
                                message={message}
                                messageType="success"
                            />
                        )}

                        {voucher.is_wholesale ? (
                            <div className="voucher-list__wrapper">
                                <Button
                                    additionalClasses="button button__primary voucher-list__button voucher-list__button--wide"
                                    onClick={() => downloadVouchersList(voucher.wholesale_voucher_url)}
                                    >
                                    <span>Download Voucher List</span>
                                </Button>
                            </div>
                        ) : null}

                        {voucher.vouchers.length > 0 && voucher.is_wholesale === false ? (
                            <VoucherList
                                vouchers={voucher.vouchers}
                            />
                        ) : null}
                    </div>
                </div>): null}
        </>
    );
};
export default Voucher;
